// なんらかのエラーが発生した際に、HTMLでエラーダイアログを表示し、
// リロードやTopに戻すUIを提供する
export class WidgetErrorDialog extends HTMLElement {
    setData(setting) {
        // @ts-ignore
        const topButton = this.shadowRoot.getElementById('top');
        if (topButton) {
            // @ts-ignore
            const url = setting.url;
            if (url) {
                topButton.style.display = 'block';
                topButton.addEventListener('click', ()=>{
                    window.location.href = url;
                });
            }
            // @ts-ignore
            const buttonText = setting.buttonText;
            if (buttonText) {
                // @ts-ignore
                topButton.value = buttonText;
            }
        }
    }
    show(errorCode, detail = '') {
        // テキストとして対応
        // @ts-ignore
        const errorCodeElement = this.shadowRoot.getElementById('errorCode');
        if (errorCodeElement) {
            if (errorCodeElement.innerText !== '') {
                errorCodeElement.innerText += '\n';
            }
            if (detail !== '') {
                errorCode += ':' + detail;
            }
            errorCodeElement.innerText += errorCode;
        }
        // @ts-ignore
        const dialog = this.shadowRoot.querySelector('#container');
        if (dialog) {
            // @ts-ignore
            dialog.showModal();
        }
    }
    constructor(){
        super();
        const shadowRoot = this.attachShadow({
            mode: 'open'
        });
        // (1) このカスタム要素の文書構造を定義する
        shadowRoot.innerHTML = `
            <dialog id="container">
                <div id="message">
                エラーが発生しました<br>
                エラーコード:<br>
                <span id="errorCode"></span>
                </div>
                <div id="buttons">
                    <input type="button" id="reload" value="再読み込み">
                    <input type="button" id="top" value="Topへ移動">
                </div>
            </dialog>
            `;
        const reloadButton = shadowRoot.querySelector('#reload');
        if (reloadButton) {
            reloadButton.addEventListener('click', ()=>{
                window.location.reload();
            });
        }
        const style = document.createElement('style');
        style.textContent = `
        #container {
            min-width: 200px;
            border: 1px;
            border-radius: 20px;
            background-color: white;
            padding: 10px;
        }

        #message {
            padding: 10px;
        }

        #buttons {
            display: flex;
            justify-content: space-around;
            margin-bottom: 10px;
        }

        #top {
            display:none;
        }
        `;
        shadowRoot.append(style);
    }
}
